import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { get } from 'lodash'
import { Input, Textarea, FilePicker } from 'components/fields'
import { ElevatedButton } from 'components/layout'
import { form } from 'helpers/decorators'
import { uploadFileValidation } from 'models/awards'

@form({
  form: 'addLog',
  disableHook: true,
  validate: uploadFileValidation
})
class FileUpload extends Component {
  static propTypes = {
    awardId: PropTypes.number,
    sectionId: PropTypes.string,
    category: PropTypes.string,
    loading: PropTypes.bool,
    values: PropTypes.object,
    onSubmit: PropTypes.func.isRequired,
    change: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired
  }

  render() {
    const { handleSubmit, awardId, sectionId, category, values, loading } = this.props

    return (
      <form
        onSubmit={handleSubmit(fields => this.props.onSubmit(awardId, fields, sectionId, category)
        )}
      >
        <Input label="Title" intlKey="label.title" name="title" />
        <Textarea
          label="Description"
          intlKey="label.description"
          name="description"
        />
        <div className="base-margin desc">
          <FilePicker name="file" change={this.props.change} />
        </div>

        <ElevatedButton
          intlKey="button.add_file"
          disabled={!get(values, 'file')}
          isLoading={loading}
          submit
          rounded
          uppercase
          fullWidth
        >
          Add file
        </ElevatedButton>
      </form>
    )
  }
}

export default FileUpload
